package com.taager.dukan.feature.checkout.success

sealed interface CheckoutSuccessViewEvent {
    data class Init(val key: String?) : CheckoutSuccessViewEvent
    object BackToHomeClick : CheckoutSuccessViewEvent
    data class ContactEmailClick(val email: String) : CheckoutSuccessViewEvent
}
